module.exports = __webpack_public_path__ + "static/media/accessories-8.035dd314.jpg";